import React from 'react';
import CollapsableCard, { useUpdateCollapsableHeight } from '../CollapsableCard';
import LocationRequestConfigForm from '../sdk/LocationRequestConfigForm';

const CollapsableLocationRequestConfig = ({icon, title, data, closeBtnText, onSave}) => {
  const { ref, active, setActive, collapseHeight, updateHeight } = useUpdateCollapsableHeight()

  return (
    <CollapsableCard
      icon={icon}
      title={title}
      active={active}
      setActive={setActive}
      collapseHeight={collapseHeight}
      closeBtnText={closeBtnText}
      ref={ref}
      >
      <LocationRequestConfigForm
        locations_request_config={data}
        inherited_locations_request_config={data.inherited}
        onHeightChange={()=>(updateHeight())}
        onSave={onSave}
        />
    </CollapsableCard>
  )
}

export default CollapsableLocationRequestConfig
